import React from "react";
import Navbutton from "../navbutton/Navbutton";
import fundofolha from "../image/fundofolha.jpg";
import './Blog.css';
import SiYourtraveldottv from "../image/SiYourtraveldottv.png";
import Header from "../components/Header";

const ArticlePage = () => {
  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div className="article-container">
      <Header/>

      <header className="article-header">
        <h1 className="article-title">Bem-vindos ao <span>Blog</span> da Biolink Soluções Ambientais!</h1>
        <p className="article-date">Publicado em: 15 de Janeiro de 2025</p>
      </header>

      <section className="article-main-content">
        <img
          src={SiYourtraveldottv} // Substitua pelo caminho da imagem
          alt="Biolink Soluções Ambientais"
          className="article-image"
        />
        <p className="article-paragraph">
          Estamos extremamente felizes em inaugurar este espaço dedicado a compartilhar conhecimento, experiências e novidades sobre o universo da sustentabilidade e consultoria ambiental.
        </p>
        <ul className="article-list">
          <li>Dicas e boas práticas ambientais;</li>
          <li>Inovações no setor de consultoria ambiental;</li>
          <li>Informações sobre legislações e licenças ambientais;</li>
          <li>Curiosidades (que geram conhecimento!);</li>
          <li>Histórias inspiradoras de projetos que impactam positivamente o meio ambiente.</li>
        </ul>
        
        <p className="article-paragraph">
          Na Biolink, contamos com uma equipe multidisciplinar formada por biólogos, engenheiros florestais, geógrafos, especialistas em drones e programadores. Essa diversidade de talentos nos permite oferecer soluções completas e inovadoras, pensadas para atender às necessidades específicas de cada cliente, sempre com excelência e foco na sustentabilidade.
        </p>
        <p className="article-paragraph">
          Nosso objetivo é criar uma conexão ainda mais próxima com você, trazendo conteúdos que não apenas informem, mas também inspirem ações transformadoras. Acreditamos que o conhecimento é o primeiro passo para construir um futuro mais sustentável!
        </p>
        <p className="article-paragraph">
          Não deixe de acompanhar e participar! Seus comentários, dúvidas e sugestões serão sempre bem-vindos. Agradecemos por se juntarem a nós nesta nova e tão importante etapa.
        </p>
        <p className="article-paragraph">
          Vamos juntos nesta jornada? Acompanhe nosso blog e descubra como podemos transformar o presente para garantir um futuro mais verde.
        </p>
        <p className="article-paragraph">
          #Biolink #BlogBiolink #Sustentabilidade #ConsultoriaAmbiental #MeioAmbiente
        </p>
      </section>

    

      <div className="back-button-container">
        <button onClick={handleGoBack} className="back-button">
          <i className="fas fa-arrow-left"></i>
          Outros artigos
        </button>
      </div>

      <section
        className="footer"
        style={{
          background: `linear-gradient(rgba(255, 255, 255, 0.5), rgba(138, 138, 138, 0.5)), url(${fundofolha})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          color: "#fff",
        }}
      >
        <div className="box-container">
          <div className="box">
            <h3>Navegue</h3>
            <a href="#home"><i className="fas fa-chevron-right"></i> Início</a>
            <a href="#about"><i className="fas fa-chevron-right"></i> Sobre</a>
            <a href="#services"><i className="fas fa-chevron-right"></i> Serviços</a>
            <a href="#doctors"><i className="fas fa-chevron-right"></i> Equipe</a>
            <a href="#book"><i className="fas fa-chevron-right"></i> Iniciar conversa</a>
            <a href="#review"><i className="fas fa-chevron-right"></i> Avaliações</a>
            <a href="#blogs"><i className="fas fa-chevron-right"></i> Blog</a>
          </div>

          <div className="box">
            <h3>Nossos serviços</h3>
            <a href="#services"><i className="fas fa-chevron-right"></i> Licenciamento Ambiental e Regularização</a>
            <a href="#services"><i className="fas fa-chevron-right"></i> Flora</a>
            <a href="#services"><i className="fas fa-chevron-right"></i> Fauna</a>
            <a href="#services"><i className="fas fa-chevron-right"></i> Drones e Geoprocessamento</a>
            <a href="#services"><i className="fas fa-chevron-right"></i> Treinamentos e Capacitação</a>
            <a href="#services"><i className="fas fa-chevron-right"></i> Capex Opex</a>
          </div>

          <div className="box">
            <h3>Contato</h3>
            <a href="https://wa.me/5534999203789?text=Gostaria%20de%20atendimento%20estava%20navegando%20">
              <i className="fas fa-phone"></i> (34) 9 9920-3789
            </a>
            <a href="https://wa.me/5511986321639?text=Gostaria%20de%20atendimento%20estava%20navegando%20no%20site!%20">
              <i className="fas fa-phone"></i> (11) 9 8632-1639
            </a>
            <a href="mailto:emerson@biolinksolucoes.com.br?subject=Assunto%20do%20E-mail&body=Mensagem%20inicial">
              <i className="fas fa-envelope"></i> emerson@biolinksolucoes.com.br
            </a>
            <a href="#">
              <i className="fas fa-envelope"></i> omar.neto@biolinksolucoes.com.br
            </a>
            <a href="#">
              <i className="fas fa-map-marker-alt"></i> Uberlândia, Minas Gerais
            </a>
          </div>

          <div className="box">
            <h3>Conecte-se conosco!</h3>
            <a href="https://www.instagram.com/biolink_ambiental/">
              <i className="fab fa-instagram"></i> Instagram
            </a>
            <a href="https://www.linkedin.com/company/biolink-ambiental/posts/?feedView=all">
              <i className="fab fa-linkedin"></i> LinkedIn
            </a>
          </div>
        </div>

        <div className="credit">
          Criado por <span><a href="">Biolink</a></span> | ©Todos os direitos reservados.
        </div>
      </section>
    </div>
  );
};

export default ArticlePage;